import { User } from '@ravago/shared/authentication';
import { AccessLevel } from '@ravago/shared/page-data/enums/access-level';
import { DynamicPageContentType } from '@ravago/shared/page-data/models/contentful';
import { NormalizedNavigationDropdown, NormalizedNavigationGroup, NormalizedNavigationItem } from '@ravago/shared/page-data/models/contentful-mapped';
import { AccessLevelUtils } from '@ravago/shared/page-data/utils/access-level';

export class NavigationUtils {
   static filterItemsByAccessLevel<T extends NormalizedNavigationItem | NormalizedNavigationGroup | NormalizedNavigationDropdown>(
      items: Array<T>,
      user?: User
   ): Array<T> {
      return items.filter((item) => {
         const allowedGroups = AccessLevelUtils.getUserGroupsByAccessLevel(item.accessType as AccessLevel[]);

         return AccessLevelUtils.canAccess(user, allowedGroups, false, ('identifier' in item ? item.identifier : undefined) ?? undefined);
      }) as Array<T>;
   }

   static buildRoute(locale: string, navigationItem: NormalizedNavigationItem, dynamicPageUrls?: { [key in DynamicPageContentType]?: string }) {
      let route = navigationItem.externalUrl ?? '';

      if (navigationItem.page) {
         if (navigationItem.page.contentType?.toLowerCase() === 'blogpost') {
            const blogOverview = dynamicPageUrls?.blogPost;

            route = blogOverview
               ? `/${locale}/${blogOverview.replace(':slug', navigationItem.page.route ?? '')}`
               : `/${locale}/${navigationItem.page.route}`;
         } else {
            route = `/${locale}/${navigationItem.page.route}`;
         }
      }

      if (navigationItem.slug) {
         route = route.replace(':slug', navigationItem.slug);
      }

      if (navigationItem.queryParameters) {
         route += `?${navigationItem.queryParameters}`;
      }

      return route;
   }

   static hasRoute(locale: string, navigationItem: NormalizedNavigationItem) {
      return !!this.buildRoute(locale, navigationItem);
   }
}
